import { useEffect } from 'react';

/**
 * Часы физического ожидания (07-оболочка-тз, «Физическое ожидание»).
 *
 * Считается только **активное** время игры: видимая вкладка, окно в фокусе,
 * закрытые оверлеи. Настенные часы и внутриигровая дата не участвуют — ждать
 * должен игрок, а не его компьютер, и свернуть вкладку на минуту не значит
 * отсидеть экспертизу.
 *
 * Из этого же следует, что справочник и меню ожидание ставят на паузу, а не
 * наказывают: посмотреть, что такое «трасология», игроку никто не запрещал,
 * и прожитые секунды за это не отбирают. Решает про оверлеи вызывающий —
 * он один знает, что сейчас на экране.
 *
 * Обратного отсчёта на экране нет намеренно: время становится видимым только
 * авторским действием вроде «посмотреть на часы». Поэтому хук ничего не рисует
 * и наружу отдаёт лишь прибавку.
 */

/**
 * Такт. Полсекунды, потому что точность здесь никому не нужна: экран времени
 * не показывает, а условия у автора — целые секунды. Реже — и переход после
 * девяностой секунды заметно опоздает, чаще — лишние записи в сейв.
 */
const TICK = 500;

/** Считается ли время прямо сейчас: вкладка видна и окно в фокусе. */
function live(): boolean {
  return document.visibilityState === 'visible' && document.hasFocus();
}

/**
 * `active` — есть ли что считать (незаконченное ожидание при активной игре).
 * `add` получает прожитые миллисекунды: между тактами меряем `performance.now()`,
 * а не считаем такты, — интервал в фоне тормозят, и по тактам ожидание вышло бы
 * длиннее заявленного.
 */
export function useWaitClock(active: boolean, add: (ms: number) => void): void {
  useEffect(() => {
    if (!active) return;
    let last = performance.now();
    const id = setInterval(() => {
      const now = performance.now();
      const passed = now - last;
      last = now;
      if (live()) add(passed);
    }, TICK);
    return () => clearInterval(id);
  }, [active, add]);
}
